import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/auth/updateProfile';
import config from '../../../config';
import { getLocalUser, isAuthenticated } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const profileData = action.payload;

    if (!isAuthenticated()) {
      throw new Error('Not authenticated');
    }
    
    const response = yield call(axios.post, 
      `${config.API_URL}/user/update-profile`,
      profileData,
      { 
        headers: {
          'Content-Type': 'application/json',
          ...getLocalUser()
        }
      }
    );
    
    // Update stored user data. The API wraps payloads in a ``data``
    // envelope (responseJSON) — tolerate both shapes so the stored
    // user (which utils/datetime reads the timezone from) never gets
    // clobbered with ``undefined``.
    const payload = response.data?.data ?? response.data ?? {};
    if (payload.user) {
      localStorage.setItem('user', JSON.stringify(payload.user));
    }

    yield put(fetchSuccess(payload));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
